import { Data } from '@blade/std-lib'

import type {
  BondingCurve,
  PairFromMigration,
  PairToMigration,
} from './pair-extra-details'

export class Bonding extends Data.Class<BondingCurve> {}
export class MigratedTo extends Data.Class<{
  migration: PairToMigration
}> {}
export class MigratedFrom extends Data.Class<{
  migration: PairFromMigration
}> {}
export class MigratedFlag extends Data.Class {}
export class None extends Data.Class {}

export type PairMigrationStatus =
  | Bonding
  | MigratedTo
  | MigratedFrom
  | MigratedFlag
  | None

export const isMigrated = (status: PairMigrationStatus) => {
  return (
    status instanceof MigratedFrom ||
    status instanceof MigratedTo ||
    status instanceof MigratedFlag
  )
}
